import { Component, inject } from '@angular/core';
import { DialogService } from '../../../auxiliares/dialog/dialog.service';
import { LoginService } from '../../login/login.service';
import { EnvService } from '../../../env';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { WebSocketService } from '../../../auxiliares/servicios/websocket.service';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrl: './version.component.scss',
  standalone: false,
})
export class VersionComponent {
  private dialog = inject(DialogService);
  helper = inject(HelperService);
  private webSocket = inject(WebSocketService);

  envService = inject(EnvService);
  public version = this.envService.APP_VERSION;
  public env = this.envService.ENV;
  public wsConnected = this.webSocket.connected;

  public async logout() {
    const res = await this.dialog.confirm(
      'Cerrar sesión',
      '¿Confirmás que querés cerrar sesión?',
    );
    if (res) {
      LoginService.removeLoginInfo();
      window.location.href = '/';
    }
  }
}
